import React, {useEffect} from "react";
import {
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell,
    User,
    Chip,
    Tooltip,
    getKeyValue,
    ButtonGroup, Button
} from "@nextui-org/react";
import {FaEdit, FaRegPauseCircle, FaRegPlayCircle, FaEye, FaPlusCircle} from 'react-icons/fa'
import {getProducts, Products_Activated} from "../API";
import {useNavigate} from "react-router-dom";

const statusColorMap = {
    sale_price: "success",
    cost: "warning",
    tax: "danger",
};

export default function Products() {
    const [products, setProducts] = React.useState([]);
    const navigate = useNavigate();
    const columns = [
        {name: "NOMBRE", uid: "name"},
        {name: "CATEGORIA", uid: "category"},
        {name: "DESCRIPCION", uid: "desc"},
        {name: "PRECIO", uid: "sale_price"},
        {name: "IVA", uid: "tax"},
        {name: "COSTO", uid: "cost"},
        {name: "IMAGEN", uid: "img"},
        {name: "ACCIONES", uid: "actions"},
    ];

    const imgUrl = "https://expendedora.online/img/";
    useEffect(() => {
        Starting();
    }, []);

    async function Starting() {
        const p = await getProducts();
        setProducts(p);
    }

    async function Activated(product){
        const res = await Products_Activated(product);
        if(res === 200)
            setProducts(prevProducts =>
                prevProducts.map(item =>
                    item.idproduct === product.idproduct ? { ...item, active: product.active === 1 ? 0 : 1 } : item
                )
            );
    }

    function GoToDetails(data) {
        navigate("/dashboard/products-details", {state: {data}});
    }

    const renderCell = React.useCallback((product, columnKey) => {
        const cellValue = product[columnKey];
        switch (columnKey) {
            case "img":
                return <User avatarProps={{radius: "lg", src: imgUrl + product.image}}></User>;

            case "sale_price":
            case "cost":
            case "tax":
                return (
                    <Chip className="capitalize" color={statusColorMap[columnKey]} size="sm" variant="flat">
                        Gs. {cellValue}
                    </Chip>
                );

            case "actions":
                return (
                    <div className="relative flex items-center gap-2">

                        <Button onClick={() => GoToDetails(product)} color="transparent" isIconOnly>
                            <Tooltip content="Editar producto">
                                  <span className="text-lg text-default-400 cursor-pointer active:opacity-50">
                                    <FaEdit/>
                                  </span>
                            </Tooltip>
                        </Button>
                        <Button onClick={() => Activated(product)} color="transparent" isIconOnly>
                            {
                                product.active ? (

                                    <Tooltip color="danger" content="Desactivar producto">
                                      <span className="text-lg text-danger cursor-pointer active:opacity-50">
                                        <FaRegPauseCircle/>
                                      </span>
                                    </Tooltip>
                                ) : (
                                    <Tooltip color="success" content="Activar producto">
                                      <span className="text-lg text-success cursor-pointer active:opacity-50">
                                        <FaRegPlayCircle/>
                                      </span>
                                    </Tooltip>
                                )
                            }
                        </Button>


                    </div>
                );
            default:
                return cellValue;   
        }
    }, []);

    return (
        <div className="container flex flex-col">
            <h1 className="text-center pb-2 text-2xl">Productos</h1>
            <div>
                <ButtonGroup className="p-3">
                    <Button onClick={()=>GoToDetails([])}><FaPlusCircle className="text-success"/> Producto</Button>
                    {/*<Button><FaPlusCircle className="text-warning"/> Categoria</Button>*/}
                </ButtonGroup>

            </div>
            <Table aria-label="Productos">
                <TableHeader columns={columns}>
                    {(column) => (
                        <TableColumn key={column.uid} align={column.uid === "actions" ? "center" : "start"}>
                            {column.name}
                        </TableColumn>
                    )}
                </TableHeader>
                <TableBody items={products}>
                    {(item) => (
                        <TableRow key={item.idproduct}>
                            {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>

    );
}
